import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type {
  JobTitleApiItem,
  JobTitleApiResponse,
} from "@/actions/ssr/settings/getJobTitlesSSR";

interface JobTitleState {
  items: JobTitleApiItem[];
  totalPages: number;
  currentPage: number;
  totalItems: number;
}

const initialState: JobTitleState = {
  items: [],
  totalPages: 1,
  currentPage: 1,
  totalItems: 0,
};

const jobTitleSlice = createSlice({
  name: "jobTitle",
  initialState,
  reducers: {
    setJobTitleItems(state, action: PayloadAction<JobTitleApiItem[]>) {
      state.items = action.payload;
    },
    setJobTitlePagination(
      state,
      action: PayloadAction<{
        totalPages: number;
        currentPage: number;
        totalItems?: number;
      }>,
    ) {
      state.totalPages = action.payload.totalPages;
      state.currentPage = action.payload.currentPage;
      if (action.payload.totalItems !== undefined) {
        state.totalItems = action.payload.totalItems;
      }
    },
    setJobTitles(state, action: PayloadAction<JobTitleApiResponse>) {
      state.items = action.payload.results;
      state.totalPages = action.payload.total_pages;
      state.currentPage = action.payload.current_page;
      state.totalItems = action.payload.count;
    },
  },
});

export const { setJobTitleItems, setJobTitlePagination, setJobTitles } =
  jobTitleSlice.actions;
export default jobTitleSlice.reducer;
